import { styled } from '@mui/material/styles';
import { PAGE_Z_INDEX } from 'pages/document/page/components/StyledComponents';

export const HighlightedPolygonsWrapper = styled('div', { label: 'HighlightedPolygonsWrapper' })(() => ({
  position: 'absolute',
  left: 0,
  right: 0,
  bottom: 0,
  top: 0,
  zIndex: PAGE_Z_INDEX.HIGHLIGHTED_POLYGONS,
  userSelect: 'none',
}));
